// Validation utilities matching mobile app rules

export function validateEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export interface PasswordValidationResult {
  isValid: boolean
  errors: string[]
  strength: 'weak' | 'medium' | 'strong'
}

export function validatePassword(password: string): PasswordValidationResult {
  const errors: string[] = []

  if (password.length < 12) errors.push('At least 12 characters required')
  if (password.length > 128) errors.push('Password too long (max 128 characters)')
  if (!/[a-z]/.test(password)) errors.push('Must contain a lowercase letter')
  if (!/[A-Z]/.test(password)) errors.push('Must contain an uppercase letter')
  if (!/[0-9]/.test(password)) errors.push('Must contain a number')
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/.test(password))
    errors.push('Must contain a special character (!@#$%^&* etc.)')

  const strength = getPasswordStrength(password)
  return { isValid: errors.length === 0, errors, strength }
}

export function getPasswordStrength(password: string): 'weak' | 'medium' | 'strong' {
  let score = 0
  if (password.length >= 12) score++
  if (password.length >= 16) score++
  if (/[a-z]/.test(password)) score++
  if (/[A-Z]/.test(password)) score++
  if (/[0-9]/.test(password)) score++
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/.test(password)) score++

  if (score <= 2) return 'weak'
  if (score <= 4) return 'medium'
  return 'strong'
}

export function validatePhoneNumber(phone: string): boolean {
  return /^\+?[\d\s\-()]{10,}$/.test(phone)
}
